import { render, staticRenderFns } from "./Distribution.vue?vue&type=template&id=7fd44ece&"
import script from "./Distribution.vue?vue&type=script&lang=js&"
export * from "./Distribution.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\Simply\\Simply.Web.Website\\Static\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7fd44ece')) {
      api.createRecord('7fd44ece', component.options)
    } else {
      api.reload('7fd44ece', component.options)
    }
    module.hot.accept("./Distribution.vue?vue&type=template&id=7fd44ece&", function () {
      api.rerender('7fd44ece', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Js/Components/DataView/Study/Distribution.vue"
export default component.exports